export default __webpack_public_path__ + "3775f760d0681ea96b401bafffb9b327.svg";